module.exports = __webpack_public_path__ + "img/edit-profile.01062d6d.png";